import { takeEvery, fork, put, all, call, takeLatest, delay } from "redux-saga/effects"

import {
  getTrackingWithBookingAndContainer,
  deleteTracking,
  getTracking,
  getTrackings,
  postAddTracking,
  putEditTracking,
} from "helpers/services/tracking"
import {
  ADD_TRACKING,
  DELETE_TRACKING,
  EDIT_TRACKING,
  GET_TRACKING,
  GET_TRACKINGS,
} from "./actionTypes"
import {
  getTrackingsSuccess,
  getTrackingsError,
  addTrackingSuccess,
  addTrackingError,
  deleteTrackingError,
  deleteTrackingSuccess,
  editTrackingError,
  editTrackingSuccess,
  setTrackingTotalPage,
} from "./actions"
import { getTrackingError, getTrackingSuccess } from "store/actions"

const defaultLimit = 10;

function* getTrackingsOnSaga({ payload: { page, keyword } }) {
  try {
    const response = yield call(getTrackings, { page, limit: defaultLimit, keyword })
    yield delay(1000);
    if (response.trackings) {
      yield put(getTrackingsSuccess(response.trackings))
      yield put(setTrackingTotalPage(Math.ceil((response.total || 0) / defaultLimit)))
    } else {
      yield put(getTrackingsError(response.message))
    }
  } catch (error) {
    yield put(getTrackingsError(error))
  }
}

function* getTrackingOnSaga({ payload: { uid, bookingNo, containerNo } }) {
  try {
    const response = yield bookingNo !== "" && containerNo !== ""
      ? call(getTrackingWithBookingAndContainer, bookingNo, containerNo)
      : call(getTracking, uid)
    if (response.success) {
      yield put(getTrackingSuccess(response.tracking))
    } else {
      yield put(getTrackingError(response.message))
    }
  } catch (error) {
    yield put(getTrackingError(error))
  }
}

function* addTrackingOnSaga({ payload: { tracking } }) {
  try {
    const response = yield call(postAddTracking, tracking)
    if (response.success) {
      yield put(addTrackingSuccess(response.message))
    } else {
      yield put(addTrackingError(response.message))
    }
  } catch (error) {
    yield put(addTrackingError(error.message))
  }
}

function* editTrackingOnSaga({ payload: { tracking } }) {
  try {
    const response = yield call(putEditTracking, tracking)
    if (response.success) {
      yield put(editTrackingSuccess(response.message))
    } else {
      yield put(editTrackingError(response.message))
    }
  } catch (error) {
    yield put(editTrackingError(error.message))
  }
}

function* deleteTrackingOnSaga({ payload: { tracking } }) {
  try {
    const response = yield call(deleteTracking, tracking)
    if (response.success) {
      yield put(deleteTrackingSuccess(response.message))
    } else {
      yield put(deleteTrackingError(response.message))
    }
  } catch (error) {
    yield put(deleteTrackingError(error.message))
  }
}

function* TrackingSaga() {
  yield takeLatest(GET_TRACKINGS, getTrackingsOnSaga)
  yield takeEvery(GET_TRACKING, getTrackingOnSaga)
  yield takeEvery(ADD_TRACKING, addTrackingOnSaga)
  yield takeEvery(EDIT_TRACKING, editTrackingOnSaga)
  yield takeEvery(DELETE_TRACKING, deleteTrackingOnSaga)
}

export default TrackingSaga
